import React, { useEffect } from "react";
import {
  Typography,
  Paper,
  Avatar,
  Grid,
  Box,
  Card,
  CardHeader,
  CardContent,
  Button,
} from "@mui/material";
import { AccountCircle } from "@mui/icons-material";
import { useFetchMyAccountDataQuery } from "../../api/MyAccountPageApi";
import { useNavigate } from "react-router";
import { useNavbar } from "../../context/NavBarContext";
import { IoChevronBack } from "react-icons/io5";

/** Loading */
import MyAccountLoading from "../../components/skeletonLoading/myAccountLoading/MyAccountLoading";

/** Error Screen */
import { NotFound } from "../error/NotFound_404";

const MyAccount = () => {
  const Navbar = useNavbar();
  const navigate = useNavigate();
  const { data, error, isFetching, refetch } = useFetchMyAccountDataQuery();

  useEffect(() => {
    refetch();
  }, []);

  const handleSubscriptionButtonClick = () => {
    navigate("/account/purchase_subscription", {state: {fromMyAccount: true, subscription_status: data?.subscription_status}});
  };

  if(isFetching) {
    return <MyAccountLoading />
  }

  if (error) {
    return <NotFound error={error} />;
  }
  // useLayoutEffect(() => {
  //   Navbar.setToPrevPage(1);
  //   Navbar.setLogoPlace("My Account");
  //   Navbar.setTogglePlace(<IoChevronBack fontSize="20" />);
  // }, []);

  return (
    data &&
    data?.status === 1 && (
      <Card>
        <CardHeader
          sx={{
            textAlign: "center",
            fontWeight: "bold",
          }}
          title={
            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent="center"
            >
              <Grid
                item
                xs={12}
                md={4}
                className="text-center"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Avatar className="avatar" alt="User Avatar">
                  <AccountCircle
                    style={{
                      fontSize: 50,
                      color: "#eab308",
                      backgroundColor: "black",
                    }}
                  />
                </Avatar>
              </Grid>
              <Grid
                item
                xs={12}
                md={8}
                className="text-center"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ fontWeight: "800" }}
                >
                  My Account
                </Typography>
              </Grid>
            </Grid>
          }
        />

        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={8}>
              <Typography
                variant="body2"
                color="textSecondary"
                className="inline"
                sx={{
                  fontWeight: "600",
                }}
              >
                User ID :{" "}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                className="inline"
                sx={
                  {
                    // display: "inline-block",
                  }
                }
              >
                {data.user_id}
              </Typography>
            </Grid>

            {/* <Grid item xs={12}>
              <div className="mt-4">
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{
                    fontWeight: "600",
                  }}
                >
                  Subscription Details
                </Typography>
              </div>
            </Grid> */}

            <Grid item xs={12} md={8}>
              <Typography
                variant="body2"
                color="textSecondary"
                className="inline"
                sx={{
                  fontWeight: "600",
                }}
              >
                Balance :{" "}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                className="inline"
              >
                <span className="font-semibold">
                  {" "}
                  {data.current_balance} MMK
                </span>
              </Typography>
            </Grid>


            {data.subscription_status === 1 && (
              <Grid item xs={12} md={8}>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  className="inline"
                  sx={{
                    fontWeight: "600",
                  }}
                >
                  Subscription Period :{" "}
                </Typography>
                <Typography variant="body2" color="textSecondary" className="inline">
                  <span className="font-semibold">{data.from_date}</span> to{" "}
                  <span className="font-semibold">{data.to_date}</span>
                </Typography>
              </Grid>
            )}

            <Grid item xs={12} md={8}>
              <Typography
                variant="body2"
                color="textSecondary"
                className="inline"
                sx={{
                  fontWeight: "600",
                }}
              >
                Status :{" "}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                className="inline"
              >
                <span className="font-semibold">
                  {" "}
                  {data.subscription_status === 1
                    ? "ဝန်ဆောင်မှုရယူထားပြီးဖြစ်ပါသည်"
                    : "ဝန်ဆောင်မှုရယူထားခြင်းမရှိပါ။"}
                </span>
              </Typography>
            </Grid>

            {/* <Grid item xs={12}>
              <div className="mt-4">
                <Typography variant="h6">Login Details</Typography>
                <Typography variant="body2" color="textSecondary">
                  Type: {data.login_type}
                </Typography>
              </div>
            </Grid> */}

            {/* <Grid item xs={12}>
              <div className="mt-4">
                <Typography variant="h6">Account Balance</Typography>
                <Typography variant="body2" color="textSecondary">
                  Current Balance: {data.current_balance}
                </Typography>
              </div>
            </Grid> */}
          </Grid>
          <Box className="mt-6 text-center">
            <Button
              size="small"
              variant="contained"
              disabled={data.subscription_status === 1}
              disableRipple
              onClick={handleSubscriptionButtonClick}
              sx={{
                paddingTop: "5px",
                paddingBottom: "5px",
                paddingRight: "10px",
                paddingLeft: "10px",
                borderTopLeftRadius: "50px", // Adjust the radius value as needed
                borderBottomLeftRadius: "50px", // Adjust the radius value as needed
                borderTopRightRadius: "50px", // No rounding on the right-top corner
                borderBottomRightRadius: "50px", // No rounding on the right-bottom corner
                backgroundColor: data.subscription_status === 1 ? "#f3f4f6" : "#facc15",
                color: data.subscription_status === 1 ? "#8b8b8b" : "black",
                "&:hover": {
                  backgroundColor: data.subscription_status === 1 ? "#f3f4f6" : "#eab308", // Change hover background color if disabled
                  borderColor: data.subscription_status === 1 ? "#f3f4f6" : "#eab308", // Change border color if disabled
                  boxShadow: "none",
                },
                "&:active": {
                  boxShadow: "none",
                  backgroundColor: data.subscription_status === 1 ? "#f3f4f6" : "#facc15", // Change active background color if disabled
                  borderColor: data.subscription_status === 1 ? "#f3f4f6" : "#ca8a04", // Change active border color if disabled
                },
              }}
            >
              ဝန်ဆောင်မှု ရယူမည်။
            </Button>
          </Box>
        </CardContent>
      </Card>
    )
  );
};

export default MyAccount;
